<app-header-simple></app-header-simple>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Información del Partido
                </h2>
                <div class="text-center text-white" style='font-family: "Poppins", sans-serif;' *ngIf="!isLoading">{{partido.contrincante1}} {{partido.resultado1}} vs
                    {{partido.resultado2 }} {{partido.contrincante2}}</div>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <app-loader *ngIf="isLoading"></app-loader>
                    <div *ngIf="!isLoading" class="animate__animated animate__faster animate__fadeInDown">
                        <div class="table-responsive mt-3">
                            <table class="table table-bordered table-sm" id="tablePartidos">
                                <thead>
                                    <tr>
                                        <th class="text-white" scope="col">NOMBRE</th>
                                        <th scope="col" class="text-center text-white" colspan="4"
                                            style="border-top: 0px;"></th>
                                        <th scope="col" class="text-center text-white">PTS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let participante of participantes">
                                        <td class="text-white"><a routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.nombre.substr(0,10)}}</a>
                                        </td>
                                        <td class="text-white d-block d-sm-block d-md-none"><a
                                                routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.contrincante1.substr(0,3)}}</a>
                                        </td>
                                        <td class="text-white d-none d-sm-none d-md-block"><a
                                                routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.contrincante1}}</a>
                                        </td>
                                        <td class="text-white"><a routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.resultado1}}</a>
                                        </td>
                                        <td class="text-white"><a routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.resultado2}}</a>
                                        </td>
                                        <td class="text-white d-block d-sm-block d-md-none"><a
                                                routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.contrincante2.substr(0,3)}}</a>
                                        </td>
                                        <td class="text-white d-none d-sm-none d-md-block"><a
                                                routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.contrincante2}}</a>
                                        </td>
                                        <td class="text-white"><a routerLink="/jugador/{{participante.$key}}"
                                                style="text-decoration: none;color: white;">{{participante.ppr +
                                                participante.ppe}}</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="container animate__animated animate__faster animate__fadeInDown">
                            <h5 class="mt-4 mb-3">
                                Pronósticos del partido
                            </h5>
                            <div class="row">
                                <div class="col-sm">
                                    <p style="font-size: 12px;width: 100%;margin: 0 0 0 0;"> Que
                                        gana
                                        {{partido.contrincante1}} {{porcentaje.equipo1}} personas</p>
                                    <div class="div-bar mb-2">
                                        <div class="bar" [style.width.%]="porcentaje.porcentajeEquipo1">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="col-sm">
                                    <p style="font-size: 12px;width: 100%;margin: 0 0 0 0;"> 
                                        Que gana 
                                        {{partido.contrincante2}} {{porcentaje.equipo2 }} personas</p>
                                    <div class="div-bar mb-2">
                                        <div class="bar" [style.width.%]="porcentaje.porcentajeEquipo2">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="col-sm">
                                    <p style="font-size: 12px;width: 100%;margin: 0 0 0 0;"> Que queda en
                                        empate {{porcentaje.empate}} personas</p>
                                    <div class="div-bar mb-2">
                                        <div class="bar" [style.width.%]="porcentaje.porcentajeEmpate">&nbsp;</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section><!-- End Services Section -->
            </div>
        </div>
    </div>



    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section><!-- End Hero -->